import { DesignElementBase, DesignElementGroupableRequiredPart, DesignElementSlugPart, } from "./base";
import { DocumentationPageDataV1, ElementGroupDataV1 } from "./data";
import { ElementGroup } from "./group";
import { z } from "zod";
//
// Documentation page
//
export const DocumentationPageV1 = DesignElementBase.extend(DesignElementGroupableRequiredPart.shape)
    .extend(DesignElementSlugPart.shape)
    .extend({
    shortPersistentId: z.string(),
    data: DocumentationPageDataV1,
});
//
// Documentation group (legacy)
//
export const DocumentationGroupV1 = ElementGroup.omit({
    data: true,
}).extend({
    data: ElementGroupDataV1.optional(),
});
